import { Channel, UserType } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { useOperationsContext } from '@/contexts/OperationsContext/OperationsContext';
import { useUser } from '@/hooks/useUser';

export const useChannelSelector = () => {
  const { structure, userEntity, isUserChannel, isUserMerchant } = useUser();
  const {
    state: { selectedChannel },
    actions: { updateOperationsContext },
  } = useOperationsContext();

  useEffect(() => {
    updateOperationsContext({ selectedChannel: getSelectedChannelByUserType() });
    return () => {
      updateOperationsContext({ selectedChannel: undefined });
    };
  }, []);

  useEffect(() => {
    if (selectedChannel && structure) {
      updateOperationsContext({
        selectedChannel: structure.merchant.channels.find((channel) => channel.id === selectedChannel.id),
      });
    }
  }, [structure]);

  const setSelectedChannel = (channel: Channel | undefined) => updateOperationsContext({ selectedChannel: channel });

  const getSelectedChannelByUserType = () => {
    if (userEntity?.isUserType(UserType.AGENT) || userEntity?.isUserType(UserType.CHANNEL)) return userEntity.channel;
    return undefined;
  };

  return {
    allChannels: structure?.merchant.channels,
    selectedChannel,
    setSelectedChannel,
    userEntity,
    isUserChannel,
    isUserMerchant,
  };
};
